import { render, staticRenderFns } from "./read-qa.vue?vue&type=template&id=1eea034e&scoped=true&"
import script from "./read-qa.vue?vue&type=script&lang=ts&"
export * from "./read-qa.vue?vue&type=script&lang=ts&"
import style0 from "./read-qa.vue?vue&type=style&index=0&id=1eea034e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eea034e",
  null
  
)

export default component.exports